
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12343',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12343",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.468",
  "data-fetching-client": "static-1.9690",
  "foundations-components": "static-1.7981",
  "foundations-components-legacy": "static-1.1006",
  "foundations-theming": "static-1.4443",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8036",
  "hub-http-shared-msw-handlers": "static-1.10021",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11495",
  "I18n": "static-7.1631",
  "jasmine-runner": "static-1.6486",
  "marketplace-storefront-base": "static-1.12404",
  "quartz": "static-1.7060",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16694",
  "reactive-variable-buffer-atom": "static-1.2881",
  "reporting-testing-lib": "static-1.9590",
  "settings-ui-lib": "static-1.12543",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7182",
  "ui-addon-i18n": "static-1.11171",
  "ui-addon-react-router-dom": "static-1.9565",
  "unified-auth": "static-1.519",
  "unified-auth-core-lib": "static-1.801",
  "usage-tracker": "static-1.7370",
  "usage-tracker-core": "static-1.7220",
  "customer-data-property-utils": "static-1.8113",
  "hub-http": "static-1.6244",
  "integrations-lib": "static-1.16230",
  "marketplace-ui-common": "static-1.19820",
  "property-management-iframe": "static-1.13239",
  "quartz-config": "static-1.838",
  "quartz-core": "static-1.6279",
  "quartz-routing": "static-1.490",
  "quick-fetch": "static-1.3933",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4675",
  "ts-schema": "static-1.4097",
  "ui-universal-auth": "static-1.9005",
  "UIComponents": "static-3.8441",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3416",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3337",
  "quartz-webpack": "static-1.3284",
  "bend-plugin-quartz-routing": "static-1.138",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4250",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4891",
  "foundations-theming-specialty": "static-1.2159",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9447",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5361",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2018",
  "ui-fonts": "static-1.757",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-theming": "static-1.2926",
  "foundations-theming-base": "static-1.3428",
  "stylex": "static-1.33",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3147",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4350",
  "ai-components-ui-library": "static-1.9035",
  "ai-rendering-library": "static-1.10255",
  "chirp-fetch": "static-1.1910",
  "connections-embed-lib": "static-1.1031",
  "copilot-toolkit": "static-1.11195",
  "feedback-loader": "static-1.29337",
  "laboratory-lib": "static-3.7178",
  "marketplace-embed": "static-1.22154",
  "marketplace-ui-details": "static-1.9716",
  "marketplace-ui-reviews": "static-1.19776",
  "marketplace-ui-tracking": "static-1.13991",
  "sanitize-text": "static-1.8165",
  "ui-addon-video-player": "static-1.8725",
  "usage-tracker-multi": "static-1.5784",
  "usage-tracker-session-replay": "static-1.5056",
  "wootric-nps": "static-1.6997",
  "quartz-head": "static-1.725",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4674",
  "immer": "static-1.33",
  "immerable": "static-1.4176",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2500",
  "reporting-data": "static-1.67657",
  "cssUtils": "static-1.798",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11802",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10230",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10389",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7360",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18353",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4538",
  "foundations-components-test-utils": "static-1.5464",
  "quartz-i18n": "static-1.735",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.311",
  "microsoft-drive-integration-lib": "static-1.443",
  "slack-ui-library": "static-1.10415",
  "fsm": "static-1.3754",
  "customer-data-objects": "static-1.7693",
  "property-translator": "static-1.5422",
  "hs-locale-management": "static-1.97",
  "frontend-preferences-client": "static-1.7950",
  "hs-promise-utils": "static-1.5613",
  "hubspot-apollo-client": "static-1.4902",
  "integrations-error-boundary-lib": "static-1.13645",
  "integrations-tracking-lib": "static-1.5624",
  "native-integrations-shared-strings": "static-1.7804",
  "reselect": "static-2.16",
  "sanitize": "static-1.4499",
  "superstore": "static-1.4784",
  "ui-shepherd-react": "static-3.10191",
  "ai-settings-ui-library": "static-1.7920",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4668",
  "immutable-less": "static-1.4676",
  "marketplace-ui-client-types": "static-1.17227",
  "nav-meta": "static-1.29744",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10270",
  "ui-addon-upgrades": "static-9.18030",
  "inbound-db-properties-service-client": "static-1.3863",
  "property-management-common": "static-1.5527",
  "ui-addon-iframeable": "static-1.9081",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.735",
  "quartz-test": "static-1.735",
  "quartz-tracking": "static-1.439",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.85",
  "bender-build-tools": "static-1.3215",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21412",
  "ContentUtils": "static-1.68436",
  "customer-data-objects-ui-components": "static-1.13051",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.75",
  "avatar-components": "static-1.2521",
  "customer-data-filters-ui": "static-1.39883",
  "customer-data-reference-ui-components": "static-1.13188",
  "embedded-academy-lib": "static-1.14424",
  "ExportDialog": "static-6.10407",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41372",
  "reporting-snowflake": "static-1.56275",
  "reporting-ui-components": "static-2.64928",
  "reporting-visualizations": "static-1.59733",
  "ui-addon-teams": "static-1.21587",
  "magpie-lib": "static-1.5565",
  "navigation-components": "static-1.18107",
  "magpie-types": "static-1.5025",
  "simple-logging-lib": "static-1.3073",
  "ai-studio-lib": "static-1.11686",
  "app-governance-lib": "static-1.1613",
  "developer-experience-shared-components": "static-1.10532",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8021",
  "ui-product-approvals": "static-1.28209",
  "ui-tool-access": "static-1.10170",
  "usage-based-billing-components-lib": "static-1.9004",
  "usage-tracker-anonymous": "static-1.5787",
  "usage-tracker-public": "static-1.7181",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3603",
  "persist-promise": "static-1.3721",
  "reference-resolvers": "static-1.8193",
  "ui-extensibility-client-types": "static-1.3947",
  "hubspot-apollo-cache": "static-1.361",
  "universal-page-editor-lib": "static-1.3036",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2849",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5095",
  "purchase-motions-components": "static-1.5956",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1564",
  "crm-component-utils": "static-1.39143",
  "crm-properties-common-lib": "static-1.5907",
  "customer-data-properties": "static-1.51643",
  "framework-data-schema-resolvers": "static-1.6907",
  "property-value-citations": "static-1.2257",
  "reference-resolvers-lite": "static-1.8117",
  "ui-business-units-lib": "static-1.9077",
  "navigation-messaging": "static-1.7434",
  "hubspotter-http-shared-msw-handlers": "static-1.10019",
  "cms-field-types": "static-1.4835",
  "content-icons-ui": "static-1.2233",
  "customer-data-ui-utilities": "static-1.9849",
  "events-data-lib": "static-1.246",
  "conversations-skeleton-state": "static-1.7270",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22318",
  "FormUrlGenerator": "static-2.4741",
  "framework-builder-read-service-client": "static-1.4022",
  "framework-data-schema-quick-fetch": "static-1.6812",
  "multi-account-reference-resolvers": "static-1.1002",
  "onboarding-tours": "static-1.16656",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13753",
  "academy-common-lib": "static-1.13884",
  "content-assistance-lib": "static-1.7786",
  "dashboard-lib": "static-1.81626",
  "file-manager-components": "static-1.23687",
  "getting-started-shared-tasks": "static-1.18520",
  "hubspot-prosemirror": "static-1.18298",
  "hubspot-prosemirror-plugins": "static-1.18290",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19872",
  "share-with-third-party-component-lib": "static-1.8724",
  "ui-addon-draggable": "static-3.4786",
  "ui-asset-management-lib": "static-1.11067",
  "user-context": "static-1.5128",
  "growth-payments-core": "static-1.25449",
  "reporting-plugins": "static-1.10362",
  "reporting-reports": "static-1.67335",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.746",
  "nest": "static-1.250",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10649",
  "framework-listing-lib": "static-2.28776",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30772",
  "apps-service-types": "static-1.3902",
  "oauth-service-types": "static-1.4272",
  "ui-product-approvals-common": "static-1.104",
  "onboarding-scopes": "static-1.6484",
  "onboarding-tours-client": "static-1.4870",
  "platform-infra-nav-components": "static-1.7687",
  "subscription-experience-data-types": "static-1.14966",
  "crm-record-cards-service-types": "static-1.3614",
  "location-customization-utils-lib": "static-1.9335",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5959",
  "signup-constants": "static-1.18884",
  "signup-ui-url-generator": "static-2.8075",
  "trials-service-types": "static-1.3926",
  "card-properties-lib": "static-1.44258",
  "commerce-subscription-lib": "static-1.37190",
  "crm-actions": "static-1.6349",
  "crm-cards-sdk": "static-1.43660",
  "customer-data-properties-shared-msw-handlers": "static-1.9348",
  "customer-data-tracking": "static-1.6912",
  "hs-resources": "static-1.176",
  "pulse": "static-1.599",
  "calling-global-api": "static-1.64594",
  "calling-internal-common": "static-1.31325",
  "calling-lifecycle-internal": "static-1.65976",
  "calling-lifecycle-messages": "static-1.58270",
  "commerce-products-lib": "static-1.9654",
  "conditional-properties-service-client": "static-1.3814",
  "crm-links": "static-1.6317",
  "external-options-client-types": "static-1.4176",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4240",
  "meetings-icalendar-utils-lib": "static-1.654",
  "multi-currency-client-types": "static-1.3708",
  "object-builder-ui-client": "static-1.48823",
  "pipeline-validation-client-types": "static-1.3982",
  "smart-property-lib": "static-1.7206",
  "tiered-pricing": "static-1.1269",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11013",
  "crm-pipelines-api-client-types": "static-1.4156",
  "fdsr-migration-layer": "static-1.26",
  "react-dnd-compat": "static-1.4637",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.945",
  "growth-data-modal": "static-1.5463",
  "growth-onboarding-confetti": "static-1.3089",
  "growth-onboarding-next-action-utils": "static-1.1989",
  "onboarding-tours-utils": "static-1.722",
  "ui-shepherd-tracker": "static-1.7572",
  "academy-service-client": "static-1.3704",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39186",
  "FileManagerLib": "static-1.39327",
  "video-embed": "static-1.35844",
  "ui-coaching-tips": "static-1.28629",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11352",
  "video-data-lib": "static-1.35010",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8495",
  "payment-link-components": "static-1.23608",
  "ui-addon-emoji-picker": "static-1.9911",
  "EmailSignatureEditor": "static-1.24423",
  "viral-links-lib": "static-1.7089",
  "data-token-picker": "static-1.16446",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.249",
  "timezone-utils": "static-2.5267",
  "seat-types-lib": "static-1.66",
  "getting-started-shared-tasks-store": "static-1.17638",
  "ui-addon-opt": "static-4.8387",
  "campaign-roi-lib": "static-1.9186",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7348",
  "customer-data-views-management": "static-1.25512",
  "framework-data-table": "static-2.11968",
  "marketing-platform-lib": "static-1.6880",
  "nudge-client-utils": "static-1.2637",
  "nudge-custom-ui-functions": "static-1.1059",
  "app-users-service-client": "static-1.5620",
  "app-users-service-types": "static-1.5028",
  "mini-checkout-client": "static-1.26865",
  "onboarding-utils": "static-1.5376",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28614",
  "edison-service-client-types": "static-1.411",
  "crm_data": "static-4.92037",
  "customer-data-sidebar": "static-2.46086",
  "enrichment-properties-lib": "static-1.16324",
  "ui-addon-draggable-compat": "static-2.4279",
  "commerce-billing-lib": "static-1.19153",
  "commerce-shared-components-lib": "static-1.18605",
  "commerce-tools-ui-lib": "static-1.10442",
  "crm-fe-perf": "static-1.22926",
  "bend-plugin-pulse": "static-1.102",
  "directed-graph": "static-1.958",
  "event-emitter": "static-1.970",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31332",
  "shared-worker-versioning": "static-1.11059",
  "calling-usage-tracker": "static-1.6564",
  "voice-sms-access-library": "static-1.1077",
  "commerce-permissions": "static-1.792",
  "products-iframe-lib": "static-1.8004",
  "products-ui-components-shared-msw-handlers": "static-1.10403",
  "data-agent-kit": "static-1.230",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10104",
  "policy-lib": "static-1.6800",
  "react-tinymce": "static-1.55310",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10167",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54436",
  "tinymce-plugins": "static-1.57550",
  "tinymce-themes": "static-1.56406",
  "onboarding-data-sync-lib": "static-1.1992",
  "growth-onboarding-next-action-components": "static-1.2017",
  "user-context-client": "static-1.4635",
  "audio-components": "static-1.5949",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36838",
  "urlinator": "static-1.4559",
  "video-components": "static-1.13355",
  "outpost": "static-1.4202",
  "growth-onboarding-feedback-components": "static-1.6603",
  "content-media-composition-data-lib": "static-1.12396",
  "content-media-compositions": "static-2.16403",
  "media-bridge-lib": "static-1.18965",
  "commerce-tours-lib": "static-1.6146",
  "growth-onboarding-reliability": "static-1.5105",
  "sales-checkout-service-client": "static-1.3664",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21715",
  "sales-email-signature-service-client": "static-1.3866",
  "ts-utils-lib": "static-1.195",
  "breeze-engine-lib": "static-1.727",
  "crm-export-dialog": "static-1.6312",
  "crm-index-associations-lib": "static-1.6463",
  "crm-view-components": "static-1.339",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2394",
  "nudge-renderer-utils": "static-1.2713",
  "whisper-core-api": "static-1.6691",
  "InboxConnectUtils": "static-4.14882",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5606",
  "settings-content-modals": "static-1.46154",
  "crm_universal": "static-1.22046",
  "customer-data-email": "static-1.18073",
  "card-payment-highlight-lib": "static-1.37247",
  "card-subscription-highlight-lib": "static-1.39613",
  "commerce-contract-lib": "static-1.12169",
  "invoices-highlight-card-lib": "static-1.54805",
  "orders-highlight-card-lib": "static-1.21537",
  "products-highlight-card-lib": "static-1.17937",
  "quotes-highlight-card-lib": "static-1.72131",
  "crm-source-interpretation-lib": "static-1.5366",
  "utility-belt": "static-1.2557",
  "payments-enrollment-embed-lib": "static-1.22969",
  "stripe-embedded-components": "static-1.7545",
  "customer-data-rte": "static-1.33061",
  "cv-backend-services": "static-1.1553",
  "growth-onboarding-empty-states": "static-1.5775",
  "payments-post-enroll-local-storage-lib": "static-1.5131",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38221",
  "calling-orchestration-schema": "static-1.35854",
  "sales-views-client-types": "static-1.4282",
  "hub-http-contrib": "static-1.3065",
  "interframe": "static-3.4782",
  "tinymce-data": "static-1.40521",
  "ui-addon-sales-email": "static-1.5233",
  "layout-dnd-components": "static-1.12488",
  "layout-dnd-utils": "static-1.11463",
  "ui-brand-identity-lib": "static-1.15376",
  "NamespacedHubStyle": "static-2.9075",
  "meetings-connect-utils-lib": "static-1.7628",
  "social-insights-client-types": "static-1.22183",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4166",
  "checkout-sdk": "static-3.23708",
  "checkout-service-types": "static-1.3838",
  "company-details-components": "static-1.6218",
  "payment-method-components": "static-1.6926",
  "pricing-pages-ui-components": "static-1.14130",
  "quote-checkout-service-types": "static-1.3491",
  "upgrade-catalog-service-types": "static-1.3543",
  "access-control-lib": "static-1.10458",
  "EmailComponents": "static-1.54818",
  "EmailData": "static-1.53495",
  "redux-less": "static-2.9506",
  "sequences-lib": "static-1.8081",
  "ui-gdpr-components": "static-1.10373",
  "products-ui-components": "static-1.40172",
  "accounting-integrations-ui-components": "static-1.7100",
  "invoices-ui-lib": "static-1.54821",
  "commerce-products-api": "static-1.2330",
  "invoices-iframe-lib": "static-1.56879",
  "quotes-modal-lib": "static-1.102809",
  "quotes-ui-lib": "static-1.80852",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28334",
  "ContentData": "static-1.68511",
  "layout-data-lib": "static-1.9788",
  "hub-http-rxjs": "static-1.804",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3962",
  "billing-payments-client-types": "static-1.4012",
  "react-performance-metrics-lib": "static-1.578",
  "account-and-billing-fintech-outages": "static-3.18620",
  "pricing-pages-api": "static-1.13995",
  "ContentComponents": "static-2.71392",
  "marketing-contacts-lib": "static-1.10125",
  "marketing-email-service-types": "static-1.1920",
  "messaging-editing-lib": "static-1.46346",
  "messaging-usage-based-billing-components-lib": "static-1.1208",
  "automation-ui-source-apps": "static-1.18960",
  "automation-ui-types": "static-1.19878",
  "messaging-types-lib": "static-1.46083",
  "onboarding-settings-client": "static-1.4527",
  "sequences-client-types-lib": "static-1.7938",
  "commerce-tax-lib": "static-1.549",
  "price-books-api": "static-1.841",
  "price-books-components": "static-1.899",
  "property-description-translator": "static-1.3866",
  "ramp-editor": "static-1.203",
  "commerce-analytics-service-client": "static-1.3652",
  "totals-ui-components": "static-1.23669",
  "SalesContentIndexUI": "static-3.9285",
  "advanced-menus-core": "static-1.15163",
  "advanced-menus-lib": "static-1.12101",
  "ui-memberships-settings-lib": "static-1.34114",
  "segments-query-core": "static-1.1441",
  "demographics-service-types": "static-1.1675",
  "eligibility-engine-service-types": "static-1.3207",
  "automation-ui-ubb": "static-1.5794",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7361",
  "data-token-views": "static-1.16427",
  "forms-utils-lib": "static-1.12628",
  "payments-embed-points-lib": "static-1.13086",
  "simple-menus-core": "static-1.15162",
  "simple-menus-lib": "static-1.16679",
  "videoconference-integration-components": "static-1.6853",
  "marketing-contacts-client": "static-1.7539",
  "automation-applications-service-types": "static-1.3531",
  "automation-platform-service-types": "static-1.2593",
  "ContentEditorUI": "static-2.77189",
  "short-messages-app-service-client": "static-1.3991",
  "web-interactives-components": "static-1.13798",
  "web-interactives-data": "static-1.13799",
  "messaging-shared-utils-lib": "static-1.657",
  "messaging-user-info-utils-lib": "static-1.827",
  "email-portal-health-service-types": "static-1.1001",
  "line-items-api": "static-1.731",
  "commerce-totals-service-types": "static-1.3836",
  "FireAlarmUi": "static-1.4529",
  "sales-templates-service-types-lib": "static-1.4187",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21814",
  "automation-ui-usage-tracking": "static-1.21277",
  "data-studio-ubb": "static-1.2797",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27090",
  "collaboration-sidebar": "static-1.57900",
  "content-management-data-lib": "static-1.5419",
  "copilot-plugins": "static-1.11168",
  "cta-picker": "static-1.36470",
  "customer-agent-discovery-components-lib": "static-1.3152",
  "editor-components": "static-1.13260",
  "editor-iframe-lib": "static-1.8434",
  "error-messaging-js": "static-1.5215",
  "FormsCommonComponents": "static-1.85920",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10668",
  "SharedLegalStrings": "static-1.1770",
  "smart-content-core": "static-1.42512",
  "smart-content-lib": "static-1.43165",
  "social-composer-lib": "static-1.59257",
  "structured-content-lib": "static-1.25259",
  "theme-previewer-lib": "static-1.53306",
  "tinymce-copilot": "static-1.16504",
  "xray-recommendation-lib": "static-1.7940",
  "automation-ui-routing": "static-1.21235",
  "sql-reporting-client-types": "static-1.5655",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42251",
  "campaigns-utils-lib": "static-1.3204",
  "reporting-enablement": "static-1.23007",
  "chatspot-widget-iframe": "static-1.21403",
  "collaboration-sidebar-common": "static-1.2697",
  "forms-ai-lib": "static-1.4353",
  "codemirror-dlb": "static-1.58748",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6454",
  "report-customization-components": "static-1.13239",
  "data-quality-ui-library": "static-1.13096",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.385",
  "reporting-insights-lib": "static-1.1820"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12343",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.468",
  "data-fetching-client": "/data-fetching-client/static-1.9690",
  "foundations-components": "/foundations-components/static-1.7981",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1006",
  "foundations-theming": "/foundations-theming/static-1.4443",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8036",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10021",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11495",
  "I18n": "/I18n/static-7.1631",
  "jasmine-runner": "/jasmine-runner/static-1.6486",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12404",
  "quartz": "/quartz/static-1.7060",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16694",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2881",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9590",
  "settings-ui-lib": "/settings-ui-lib/static-1.12543",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11171",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9565",
  "unified-auth": "/unified-auth/static-1.519",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.801",
  "usage-tracker": "/usage-tracker/static-1.7370",
  "usage-tracker-core": "/usage-tracker-core/static-1.7220",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8113",
  "hub-http": "/hub-http/static-1.6244",
  "integrations-lib": "/integrations-lib/static-1.16230",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19820",
  "property-management-iframe": "/property-management-iframe/static-1.13239",
  "quartz-config": "/quartz-config/static-1.838",
  "quartz-core": "/quartz-core/static-1.6279",
  "quartz-routing": "/quartz-routing/static-1.490",
  "quick-fetch": "/quick-fetch/static-1.3933",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4675",
  "ts-schema": "/ts-schema/static-1.4097",
  "ui-universal-auth": "/ui-universal-auth/static-1.9005",
  "UIComponents": "/UIComponents/static-3.8441",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3416",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3337",
  "quartz-webpack": "/quartz-webpack/static-1.3284",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.138",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4250",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4891",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2159",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9447",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5361",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2018",
  "ui-fonts": "/ui-fonts/static-1.757",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2926",
  "foundations-theming-base": "/foundations-theming-base/static-1.3428",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3147",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4350",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
  "ai-rendering-library": "/ai-rendering-library/static-1.10255",
  "chirp-fetch": "/chirp-fetch/static-1.1910",
  "connections-embed-lib": "/connections-embed-lib/static-1.1031",
  "copilot-toolkit": "/copilot-toolkit/static-1.11195",
  "feedback-loader": "/feedback-loader/static-1.29337",
  "laboratory-lib": "/laboratory-lib/static-3.7178",
  "marketplace-embed": "/marketplace-embed/static-1.22154",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9716",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19776",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13991",
  "sanitize-text": "/sanitize-text/static-1.8165",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8725",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5784",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5056",
  "wootric-nps": "/wootric-nps/static-1.6997",
  "quartz-head": "/quartz-head/static-1.725",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4674",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4176",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2500",
  "reporting-data": "/reporting-data/static-1.67657",
  "cssUtils": "/cssUtils/static-1.798",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11802",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10230",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10389",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7360",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18353",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4538",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5464",
  "quartz-i18n": "/quartz-i18n/static-1.735",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.311",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.443",
  "slack-ui-library": "/slack-ui-library/static-1.10415",
  "fsm": "/fsm/static-1.3754",
  "customer-data-objects": "/customer-data-objects/static-1.7693",
  "property-translator": "/property-translator/static-1.5422",
  "hs-locale-management": "/hs-locale-management/static-1.97",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7950",
  "hs-promise-utils": "/hs-promise-utils/static-1.5613",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4902",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13645",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5624",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7804",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4499",
  "superstore": "/superstore/static-1.4784",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10191",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7920",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4668",
  "immutable-less": "/immutable-less/static-1.4676",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17227",
  "nav-meta": "/nav-meta/static-1.29744",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10270",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18030",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3863",
  "property-management-common": "/property-management-common/static-1.5527",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9081",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.735",
  "quartz-test": "/quartz-test/static-1.735",
  "quartz-tracking": "/quartz-tracking/static-1.439",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.85",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21412",
  "ContentUtils": "/ContentUtils/static-1.68436",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13051",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.75",
  "avatar-components": "/avatar-components/static-1.2521",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39883",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13188",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14424",
  "ExportDialog": "/ExportDialog/static-6.10407",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41372",
  "reporting-snowflake": "/reporting-snowflake/static-1.56275",
  "reporting-ui-components": "/reporting-ui-components/static-2.64928",
  "reporting-visualizations": "/reporting-visualizations/static-1.59733",
  "ui-addon-teams": "/ui-addon-teams/static-1.21587",
  "magpie-lib": "/magpie-lib/static-1.5565",
  "navigation-components": "/navigation-components/static-1.18107",
  "magpie-types": "/magpie-types/static-1.5025",
  "simple-logging-lib": "/simple-logging-lib/static-1.3073",
  "ai-studio-lib": "/ai-studio-lib/static-1.11686",
  "app-governance-lib": "/app-governance-lib/static-1.1613",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10532",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8021",
  "ui-product-approvals": "/ui-product-approvals/static-1.28209",
  "ui-tool-access": "/ui-tool-access/static-1.10170",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9004",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5787",
  "usage-tracker-public": "/usage-tracker-public/static-1.7181",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3603",
  "persist-promise": "/persist-promise/static-1.3721",
  "reference-resolvers": "/reference-resolvers/static-1.8193",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3947",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.361",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3036",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2849",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5095",
  "purchase-motions-components": "/purchase-motions-components/static-1.5956",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1564",
  "crm-component-utils": "/crm-component-utils/static-1.39143",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5907",
  "customer-data-properties": "/customer-data-properties/static-1.51643",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6907",
  "property-value-citations": "/property-value-citations/static-1.2257",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8117",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9077",
  "navigation-messaging": "/navigation-messaging/static-1.7434",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10019",
  "cms-field-types": "/cms-field-types/static-1.4835",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9849",
  "events-data-lib": "/events-data-lib/static-1.246",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7270",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22318",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4741",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4022",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6812",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1002",
  "onboarding-tours": "/onboarding-tours/static-1.16656",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13753",
  "academy-common-lib": "/academy-common-lib/static-1.13884",
  "content-assistance-lib": "/content-assistance-lib/static-1.7786",
  "dashboard-lib": "/dashboard-lib/static-1.81626",
  "file-manager-components": "/file-manager-components/static-1.23687",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18520",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18298",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18290",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19872",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8724",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4786",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11067",
  "user-context": "/user-context/static-1.5128",
  "growth-payments-core": "/growth-payments-core/static-1.25449",
  "reporting-plugins": "/reporting-plugins/static-1.10362",
  "reporting-reports": "/reporting-reports/static-1.67335",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.746",
  "nest": "/nest/static-1.250",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10649",
  "framework-listing-lib": "/framework-listing-lib/static-2.28776",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30772",
  "apps-service-types": "/apps-service-types/static-1.3902",
  "oauth-service-types": "/oauth-service-types/static-1.4272",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.104",
  "onboarding-scopes": "/onboarding-scopes/static-1.6484",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4870",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7687",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14966",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3614",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9335",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5959",
  "signup-constants": "/signup-constants/static-1.18884",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8075",
  "trials-service-types": "/trials-service-types/static-1.3926",
  "card-properties-lib": "/card-properties-lib/static-1.44258",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37190",
  "crm-actions": "/crm-actions/static-1.6349",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43660",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9348",
  "customer-data-tracking": "/customer-data-tracking/static-1.6912",
  "hs-resources": "/hs-resources/static-1.176",
  "pulse": "/pulse/static-1.599",
  "calling-global-api": "/calling-global-api/static-1.64594",
  "calling-internal-common": "/calling-internal-common/static-1.31325",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65976",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58270",
  "commerce-products-lib": "/commerce-products-lib/static-1.9654",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3814",
  "crm-links": "/crm-links/static-1.6317",
  "external-options-client-types": "/external-options-client-types/static-1.4176",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4240",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.654",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3708",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48823",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3982",
  "smart-property-lib": "/smart-property-lib/static-1.7206",
  "tiered-pricing": "/tiered-pricing/static-1.1269",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11013",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4156",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.26",
  "react-dnd-compat": "/react-dnd-compat/static-1.4637",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.945",
  "growth-data-modal": "/growth-data-modal/static-1.5463",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3089",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1989",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.722",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7572",
  "academy-service-client": "/academy-service-client/static-1.3704",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39186",
  "FileManagerLib": "/FileManagerLib/static-1.39327",
  "video-embed": "/video-embed/static-1.35844",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28629",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11352",
  "video-data-lib": "/video-data-lib/static-1.35010",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8495",
  "payment-link-components": "/payment-link-components/static-1.23608",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9911",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24423",
  "viral-links-lib": "/viral-links-lib/static-1.7089",
  "data-token-picker": "/data-token-picker/static-1.16446",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.249",
  "timezone-utils": "/timezone-utils/static-2.5267",
  "seat-types-lib": "/seat-types-lib/static-1.66",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17638",
  "ui-addon-opt": "/ui-addon-opt/static-4.8387",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9186",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7348",
  "customer-data-views-management": "/customer-data-views-management/static-1.25512",
  "framework-data-table": "/framework-data-table/static-2.11968",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6880",
  "nudge-client-utils": "/nudge-client-utils/static-1.2637",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1059",
  "app-users-service-client": "/app-users-service-client/static-1.5620",
  "app-users-service-types": "/app-users-service-types/static-1.5028",
  "mini-checkout-client": "/mini-checkout-client/static-1.26865",
  "onboarding-utils": "/onboarding-utils/static-1.5376",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28614",
  "edison-service-client-types": "/edison-service-client-types/static-1.411",
  "crm_data": "/crm_data/static-4.92037",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46086",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16324",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4279",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19153",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18605",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10442",
  "crm-fe-perf": "/crm-fe-perf/static-1.22926",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.102",
  "directed-graph": "/directed-graph/static-1.958",
  "event-emitter": "/event-emitter/static-1.970",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31332",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11059",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6564",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1077",
  "commerce-permissions": "/commerce-permissions/static-1.792",
  "products-iframe-lib": "/products-iframe-lib/static-1.8004",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10403",
  "data-agent-kit": "/data-agent-kit/static-1.230",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10104",
  "policy-lib": "/policy-lib/static-1.6800",
  "react-tinymce": "/react-tinymce/static-1.55310",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10167",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54436",
  "tinymce-plugins": "/tinymce-plugins/static-1.57550",
  "tinymce-themes": "/tinymce-themes/static-1.56406",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1992",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2017",
  "user-context-client": "/user-context-client/static-1.4635",
  "audio-components": "/audio-components/static-1.5949",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36838",
  "urlinator": "/urlinator/static-1.4559",
  "video-components": "/video-components/static-1.13355",
  "outpost": "/outpost/static-1.4202",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6603",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12396",
  "content-media-compositions": "/content-media-compositions/static-2.16403",
  "media-bridge-lib": "/media-bridge-lib/static-1.18965",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6146",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5105",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3664",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21715",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3866",
  "ts-utils-lib": "/ts-utils-lib/static-1.195",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.727",
  "crm-export-dialog": "/crm-export-dialog/static-1.6312",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6463",
  "crm-view-components": "/crm-view-components/static-1.339",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2394",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2713",
  "whisper-core-api": "/whisper-core-api/static-1.6691",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14882",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5606",
  "settings-content-modals": "/settings-content-modals/static-1.46154",
  "crm_universal": "/crm_universal/static-1.22046",
  "customer-data-email": "/customer-data-email/static-1.18073",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37247",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39613",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12169",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54805",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21537",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17937",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72131",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5366",
  "utility-belt": "/utility-belt/static-1.2557",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22969",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7545",
  "customer-data-rte": "/customer-data-rte/static-1.33061",
  "cv-backend-services": "/cv-backend-services/static-1.1553",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5775",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5131",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38221",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35854",
  "sales-views-client-types": "/sales-views-client-types/static-1.4282",
  "hub-http-contrib": "/hub-http-contrib/static-1.3065",
  "interframe": "/interframe/static-3.4782",
  "tinymce-data": "/tinymce-data/static-1.40521",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5233",
  "layout-dnd-components": "/layout-dnd-components/static-1.12488",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11463",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15376",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9075",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7628",
  "social-insights-client-types": "/social-insights-client-types/static-1.22183",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4166",
  "checkout-sdk": "/checkout-sdk/static-3.23708",
  "checkout-service-types": "/checkout-service-types/static-1.3838",
  "company-details-components": "/company-details-components/static-1.6218",
  "payment-method-components": "/payment-method-components/static-1.6926",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14130",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3491",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3543",
  "access-control-lib": "/access-control-lib/static-1.10458",
  "EmailComponents": "/EmailComponents/static-1.54818",
  "EmailData": "/EmailData/static-1.53495",
  "redux-less": "/redux-less/static-2.9506",
  "sequences-lib": "/sequences-lib/static-1.8081",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10373",
  "products-ui-components": "/products-ui-components/static-1.40172",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7100",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54821",
  "commerce-products-api": "/commerce-products-api/static-1.2330",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56879",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102809",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80852",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28334",
  "ContentData": "/ContentData/static-1.68511",
  "layout-data-lib": "/layout-data-lib/static-1.9788",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.804",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3962",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4012",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.578",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18620",
  "pricing-pages-api": "/pricing-pages-api/static-1.13995",
  "ContentComponents": "/ContentComponents/static-2.71392",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10125",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1920",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46346",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1208",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18960",
  "automation-ui-types": "/automation-ui-types/static-1.19878",
  "messaging-types-lib": "/messaging-types-lib/static-1.46083",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4527",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7938",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.549",
  "price-books-api": "/price-books-api/static-1.841",
  "price-books-components": "/price-books-components/static-1.899",
  "property-description-translator": "/property-description-translator/static-1.3866",
  "ramp-editor": "/ramp-editor/static-1.203",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3652",
  "totals-ui-components": "/totals-ui-components/static-1.23669",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9285",
  "advanced-menus-core": "/advanced-menus-core/static-1.15163",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12101",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34114",
  "segments-query-core": "/segments-query-core/static-1.1441",
  "demographics-service-types": "/demographics-service-types/static-1.1675",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3207",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5794",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7361",
  "data-token-views": "/data-token-views/static-1.16427",
  "forms-utils-lib": "/forms-utils-lib/static-1.12628",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13086",
  "simple-menus-core": "/simple-menus-core/static-1.15162",
  "simple-menus-lib": "/simple-menus-lib/static-1.16679",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6853",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7539",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3531",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
  "ContentEditorUI": "/ContentEditorUI/static-2.77189",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3991",
  "web-interactives-components": "/web-interactives-components/static-1.13798",
  "web-interactives-data": "/web-interactives-data/static-1.13799",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.657",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.827",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1001",
  "line-items-api": "/line-items-api/static-1.731",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3836",
  "FireAlarmUi": "/FireAlarmUi/static-1.4529",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4187",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21814",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21277",
  "data-studio-ubb": "/data-studio-ubb/static-1.2797",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27090",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57900",
  "content-management-data-lib": "/content-management-data-lib/static-1.5419",
  "copilot-plugins": "/copilot-plugins/static-1.11168",
  "cta-picker": "/cta-picker/static-1.36470",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3152",
  "editor-components": "/editor-components/static-1.13260",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8434",
  "error-messaging-js": "/error-messaging-js/static-1.5215",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85920",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10668",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1770",
  "smart-content-core": "/smart-content-core/static-1.42512",
  "smart-content-lib": "/smart-content-lib/static-1.43165",
  "social-composer-lib": "/social-composer-lib/static-1.59257",
  "structured-content-lib": "/structured-content-lib/static-1.25259",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53306",
  "tinymce-copilot": "/tinymce-copilot/static-1.16504",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7940",
  "automation-ui-routing": "/automation-ui-routing/static-1.21235",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5655",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42251",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3204",
  "reporting-enablement": "/reporting-enablement/static-1.23007",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21403",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2697",
  "forms-ai-lib": "/forms-ai-lib/static-1.4353",
  "codemirror-dlb": "/codemirror-dlb/static-1.58748",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6454",
  "report-customization-components": "/report-customization-components/static-1.13239",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13096",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.385",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1820"
}
};
